import { render, staticRenderFns } from "./SidebarLevel2.vue?vue&type=template&id=e4068d2e"
import script from "./SidebarLevel2.vue?vue&type=script&lang=js"
export * from "./SidebarLevel2.vue?vue&type=script&lang=js"
import style0 from "./SidebarLevel2.vue?vue&type=style&index=0&id=e4068d2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports